import { TFunction } from 'i18next';
import * as Yup from 'yup';

import { TLanguage } from 'config/tenancy';
import { REGEXES } from 'shared/presentation/constants';
import { isBrazilianCellphoneValid } from 'shared/presentation/helpers';

type TParams = {
  t: TFunction<'webchat'>;
  language: TLanguage;
};

export interface IPreChatFormValues {
  name: string;
  phone: string;
  terms: boolean;
}

export const PRE_CHAT_INITIAL_VALUES: IPreChatFormValues = {
  name: '',
  phone: '',
  terms: false,
};

const isPhoneValid = (phone: string, language: TLanguage) => {
  if (language === 'pt') return isBrazilianCellphoneValid(phone);

  return REGEXES.PHONE[language].test(phone);
};

export const PreChatSchema = ({ t, language }: TParams) =>
  Yup.object({
    name: Yup.string()
      .trim()
      .required(t('This field is required'))
      .matches(REGEXES.FULLNAME, t('Please, inform your name and last name')),
    phone: Yup.string()
      .required(t('This field is required'))
      .test('phone format', t('Please, inform a valid cellphone'), value =>
        value ? isPhoneValid(value, language) : false,
      ),
    terms: Yup.boolean().oneOf([true], t('Accept the terms to continue')),
  });
